<style>
#app .v-text-field .v-input__append-outer {
    margin-top: 8px !important;
}
</style>

<template>
    <div>
        <label class="is-size-4 mb-1">
            {{ label }}
        </label>
        <v-text-field
            v-model="fieldValue"
            v-mask="shortDate ? '##.####' : '##.##.####'"
            :placeholder="placeholder || 'ДД.ММ.ГГГГ'"
            v-bind="fieldAttrs"

            :style="{'height': fieldHeight}"
            :height="fieldHeight"
            >
            <template #append>
                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="slide-x-reverse-transition"
                    left
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                            <v-icon large>mdi-calendar-range</v-icon>
                        </span>
                    </template>

                    <v-date-picker
                        v-model="pickerValue"
                        @change="save"
                        v-bind="pickerAttrs"
                        />

                </v-menu>
            </template>
        </v-text-field>
    </div>
</template>

<script>
import {makeMoment} from "@/helpers/helpers"

export default {
    props: {
        value: String,
        fieldHeight: String,
        // forceValue: String,
        label: String,
        append: {
            type: String,
            default: 'D',
        },
        placeholder: String,
        rules: Array,
        disabled: Boolean,
        fieldLabel: String,
        shortDate: {
            type: Boolean,
            default: false,
        },
        outlined: Boolean,
        min: {
            type: String,
            default: '1950-01-01',
        },
        max: {
            type: String,
            default: new Date().toISOString().substr(0, 10),
        },
    },
    computed: {
        fieldValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        pickerValue: {
            get() {
                const date = makeMoment(this.fieldValue);
                return date.isValid() && date.format("YYYY-MM-DD") || this.max;
            },
            set(val) {
                this.fieldValue = makeMoment(val).format("DD.MM.YYYY");
            },
        },
        fieldAttrs() {
            return {
                type: this.shortDate ? 'month' : 'date',
                solo: !this.fieldLabel,
                label: this.fieldLabel,
                flat: true,
                outlined: this.outlined,
                readonly: this.menu,
                rules: this.rules,
                disabled: this.disabled,
                'hide-details': this.$isMobile ? 'auto' : false,
                height: "60px",
                type: "tel",
                class: "date-field"
            }
        },
        pickerAttrs() {
            return {
                locale: "ru-RU",
                color: this.$CLObject.type == 'bnpl_renessans'
                    ? '#9c6cfe'
                    : "primary",
                'no-title': true,
                max: this.max,
                min: this.min,
            }
        },
        appendText() {
            return this.append;
        },
    },
    data: () => ({
        activePicker: null,
        autofocus: false,

        menu: false,
        isHiddenForField: false,
    }),
    mounted() {
        // if (this.forceValue) {
        //     this.fieldValue = this.forceValue;
        // }
    },
    watch: {
        // forceValue(val) {
        //     this.fieldValue = val;
        // },
        menu(val) {
            val && setTimeout(
                () => (this.activePicker = this.shortDate ? 'MONTH' : 'DATE')
            );
        },
    },
    methods: {
        save(date) {
            this.$refs.menu.save(date);
        },
    },
};
</script>
